import React, { useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { userService } from '../../../utils/api/user.service';
import './PhoneUpdateModal.css';

export const PhoneUpdateModal = ({ isOpen, onClose, onSuccess }) => {
  const { user, login } = useAuth();
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!phone || phone.length < 10) {
      setError('Please enter a valid phone number');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const responseData = await userService.updateProfile(user.result._id, { phone });

      // Update local storage and context
      const updatedUser = {
        ...user,
        result: {
          ...user.result,
          phone: phone
        }
      };
      login(updatedUser);
      
      onSuccess && onSuccess(updatedUser);
      onClose();
    } catch (err) {
      console.error('Update phone error:', err);
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="phone-modal-overlay" onClick={onClose}>
      <div className="phone-modal" onClick={(e) => e.stopPropagation()}>
        <button className="phone-modal-close" onClick={onClose}>
          ×
        </button>

        <div className="phone-modal-header">
          <h2 className="phone-modal-title">Enter Phone Number</h2>
          <p className="phone-modal-subtitle">We need your phone number to proceed with the booking</p>
        </div>

        <form className="phone-modal-form" onSubmit={handleSubmit}>
          <div className="phone-modal-field">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Enter your phone number"
              disabled={loading}
              autoFocus
            />
          </div>

          {error && <p className="phone-modal-error">{error}</p>}

          <button 
            type="submit" 
            className="phone-modal-btn"
            disabled={loading}
          >
            {loading ? 'Updating...' : 'Save & Continue'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PhoneUpdateModal;
